var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIc24SocialYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  fillRule: "evenodd",
  d: "M21.256 5.78c.323.324.556.725.675 1.166.687 2.764.528 7.13.013 10a2.613 2.613 0 0 1-1.84 1.84c-1.613.44-8.106.44-8.106.44s-6.494 0-8.107-.44a2.612 2.612 0 0 1-1.84-1.84c-.69-2.752-.501-7.12-.013-9.987a2.613 2.613 0 0 1 1.84-1.84c1.613-.44 8.106-.453 8.106-.453s6.494 0 8.107.44c.44.12.842.352 1.165.675Zm-5.952 6.166-5.386 3.12v-6.24l5.386 3.12Z",
  clipRule: "evenodd"
})));
export default SvgIc24SocialYoutube;